export const APPCONFIG = {
  navCollapsed: false, // true, false
  theme: 'light', // light, dark
  defaultColor: '#2196F3', // Default HEX Color for Material 3
  AutoCloseMobileNav: true, // true, false. Automatically close sidenav on route change (Mobile only)
  productLink: 'https://www.identitydirector.com',
  pageTitle: 'Identity Director',
  version: '2026.8.0',
  trialExpirationDate: '9999-08-23' as string | null, // ISO date. Set to null to disable trial.
  // Upper limit (characters) for the query string of a search request. Search filters are sent as
  // GET query parameters; the service web.config allows 16384, but http.sys counts the request
  // line and all headers (Kerberos token, cookies) against the same 16384 bytes, so the usable
  // budget differs per user. Searches start with this value, degrade (phases, attributes, terms)
  // until every request fits, and lower the budget for the browser session when the server
  // still rejects a request because of its length.
  maxSearchQueryLength: 16000,
};

export function isTrialExpired(): boolean {
  if (!APPCONFIG.trialExpirationDate) {
    return false;
  }
  const expirationEnd = new Date(APPCONFIG.trialExpirationDate + 'T23:59:59');
  return new Date() > expirationEnd;
}

export function getTrialDaysRemaining(): number | null {
  if (!APPCONFIG.trialExpirationDate) {
    return null;
  }
  const expirationEnd = new Date(APPCONFIG.trialExpirationDate + 'T23:59:59');
  const now = new Date();
  const diff = expirationEnd.getTime() - now.getTime();
  if (diff <= 0) {
    return 0;
  }
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}
